import { all, call, put, takeEvery } from 'redux-saga/effects';
import { ActionTypes } from '../actions';
import { authAPI } from '../app/api/authApi';






function* workerLoginRequest(action: any): any {
    try {
        const { email } = action.payload;
        if (!email) {
            throw new Error('Email is required');
        }
        const result = yield call(authAPI.loginInitiate, email);
        yield put({ type: ActionTypes.LOGIN_SUCCESS, payload: result });
    } catch (error: any) {
        console.error('Login failed:', error);
        yield put({ type: ActionTypes.LOGIN_FAILURE, payload: error.message });
    }
}

function* workerNavigateRoot(): any {
    location.replace('/')
}

function workerLoginFailure(): any {
    // action.navigate('/login')
}

function workerHelloWorld(): any {
    alert('Hello World')
}

function* workerLogout(): any {
    yield call(authAPI.signOut);
    yield put({ type: ActionTypes.LOGOUT_SUCCESS });
}

function* workerLogoutSuccess(): any {
    if (typeof window !== 'undefined') {
        window.location.replace('/login')
    }
}





export function* watcherLoginRequest() {
    yield all([
        takeEvery(ActionTypes.LOGIN_REQUEST, workerLoginRequest),
        takeEvery(ActionTypes.NAVIGATE_ROOT, workerNavigateRoot),
        takeEvery(ActionTypes.LOGIN_FAILURE, workerLoginFailure),
        takeEvery(ActionTypes.LOGOUT, workerLogout),
        takeEvery(ActionTypes.LOGOUT_SUCCESS, workerLogoutSuccess),
        takeEvery(ActionTypes.HELLO_WORLD, workerHelloWorld),
        takeEvery(ActionTypes.NAVIGATE_ROOT, workerNavigateRoot)
    ])
}
